import React, { useState, useRef } from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

const Animated3DCard = ({ icon, iconColor, title, description }) => {
  const [rotation, setRotation] = useState({ rotateX: 0, rotateY: 0 });
  const cardRef = useRef(null);

  const handleMouseMove = (e) => {
    const card = cardRef.current;
    if (!card) return;

    const rect = card.getBoundingClientRect();
    // Calculate mouse position relative to center of card
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    // Calculate rotation values (max 15 degrees)
    const rotateX = ((y - centerY) / centerY) * 15; // rotateX based on vertical mouse position
    const rotateY = ((x - centerX) / centerX) * 15; // rotateY based on horizontal mouse position

    setRotation({ rotateX: -rotateX, rotateY }); // invert rotateX to get natural tilt
  };

  const handleMouseLeave = () => {
    setRotation({ rotateX: 0, rotateY: 0 });
  };

  return (
    <Card
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      sx={{
        borderRadius: "20px",
        textAlign: "center",
        padding: 3,
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        transition: "transform 0.2s ease",
        transformStyle: "preserve-3d",
        cursor: "pointer",
        // Apply rotation from state
        transform: `perspective(600px) rotateX(${rotation.rotateX}deg) rotateY(${rotation.rotateY}deg)`,
        boxShadow: "0 0 15px rgba(0,0,0,0.1)",
        "&:hover": {
          boxShadow: "0 0 45px rgba(255, 255, 255, 0.3)",
        },
      }}
    >
      <Box sx={{ fontSize: 50, mb: 2, color: iconColor, transform: "translateZ(40px)" }}>
        {icon}
      </Box>
      <CardContent sx={{ flexGrow: 1, transform: "translateZ(30px)" }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
          {title}
        </Typography>
        <Typography variant="body2">{description}</Typography>
      </CardContent>
    </Card>
  );
};

export default Animated3DCard;
